export function CommunitySchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "OnlineBusiness",
    "name": "Data Hire Club",
    "description": "Comunidade de profissionais de dados com vagas curadas, networking e gamificação",
    "url": "https://datahireclub.com.br",
    "areaServed": "BR",
    "audience": {
      "@type": "ProfessionalAudience",
      "name": "Profissionais de Dados"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "BRL",
      "availability": "https://schema.org/InStock",
      "description": "Acesso gratuito à plataforma de vagas e comunidade de dados"
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
